module.exports = __webpack_public_path__ + "img/gt.550b173f.jpg";